{
  "_comment": "Human-readable labels for Velocity component property keys surfaced in the migration guide. Keys are the full Velocity property key (component-name prefix preserved) where a precise label is desired; the document builder also falls back to a generic prettified label for any key not listed here. Expand iteratively as new component types are covered.",

  "feature-layer.portalItemId": "Portal Item ID",
  "feature-layer.url": "Feature Service URL",
  "feature-layer.layerId": "Layer ID",
  "feature-layer.outSR": "Output Spatial Reference (WKID)",
  "feature-layer.query": "Query Definition",
  "feature-layer.fields": "Fields",
  "feature-layer.timestampField": "Timestamp Field",
  "feature-layer.extent": "Query Extent",
  "feature-layer.enableRequestLogging": "Enable Request Logging",

  "http-poller.url": "Poll URL",
  "http-poller.httpMethod": "HTTP Method",
  "http-poller.httpAuthenticationType": "Authentication Type",
  "http-poller.headers": "HTTP Headers",
  "http-poller.urlParameters": "URL Parameters",
  "http-poller.isLongPolling": "Long Polling",
  "http-poller.globalDatetimeFormat": "Datetime Format",
  "http-poller.enableRequestLogging": "Enable Request Logging",

  "http-receiver.url": "Receiver URL",
  "http-receiver.httpAuthenticationType": "Authentication Type",

  "websocket.url": "WebSocket URL",
  "websocket.headers": "HTTP Headers",

  "tcp.host": "Host",
  "tcp.port": "Port",

  "kafka.brokers": "Broker List",
  "kafka.topics": "Topics",
  "kafka.authenticationType": "Authentication Type",
  "kafka.useSSL": "Use SSL",
  "kafka.username": "Username",
  "kafka.password": "Password",

  "mqtt.host": "Host",
  "mqtt.port": "Port",
  "mqtt.topic": "Topic",
  "mqtt.qos": "Quality of Service",
  "mqtt.username": "Username",
  "mqtt.password": "Password",
  "mqtt.clientid": "Client ID",

  "rss-feed.url": "Feed URL",

  "watch-file.fileDirectory": "Watch Directory",
  "watch-file.fileFilter": "File Filter",
  "watch-file.deleteFiles": "Delete Files After Read",
  "watch-file.readLines": "Read as Text Lines",
  "watch-file.linesPerBatch": "Lines Per Batch",
  "watch-file.linesBatchInterval": "Batch Interval",

  "filter-by-expression.expression": "Filter Expression (Arcade)",

  "field-calculator.fieldCalculations": "Field Calculations (Arcade)",

  "field-selector.fields": "Selected Fields",
  "field-selector.dropGeometry": "Drop Geometry",

  "field-mapper.schemaFieldMappings": "Field Mappings",
  "field-mapper.featuresPerTrack": "Features Per Track",

  "buffer-creator.bufferBy": "Buffer By",
  "buffer-creator.expression": "Buffer Expression (Arcade)",
  "buffer-creator.fieldName": "Buffer Field",
  "buffer-creator.distance": "Buffer Distance",
  "buffer-creator.method": "Buffer Method",

  "incident-detector.openCondition": "Open Condition",
  "incident-detector.ocExpression": "Open Expression (Arcade)",
  "incident-detector.ocSpatialRelationship": "Open Spatial Relationship",

  "feat-lyr-new.name": "Output Layer Name",
  "feat-lyr-new.portalItemId": "Portal Item ID",
  "feat-lyr-new.layerId": "Layer ID",
  "feat-lyr-new.useSpatiotemporal": "Use Spatiotemporal Store",
  "feat-lyr-new.updateExistingFeatures": "Update Existing Features",
  "feat-lyr-new.dataRetentionStrategy": "Data Retention Strategy",

  "feat-lyr-existing.name": "Target Layer Name",
  "feat-lyr-existing.portalItemId": "Portal Item ID",
  "feat-lyr-existing.layerId": "Layer ID",
  "feat-lyr-existing.updateExistingFeatures": "Update Existing Features",
  "feat-lyr-existing.keepLatest": "Keep Latest Feature",

  "kafka.topics_output": "Topics",

  "email.smtpServer": "SMTP Server",
  "email.port": "SMTP Port",
  "email.smtpServerSecurity": "Connection Security",
  "email.username": "Username",
  "email.password": "Password",
  "email.fromEmailAddress": "From Address",
  "email.toEmailAddress": "To Address",
  "email.subject": "Subject",
  "email.messageBody": "Message Body",

  "http.url": "Endpoint URL",
  "http.httpMethod": "HTTP Method",
  "http.httpAuthenticationType": "Authentication Type",
  "http.contentType": "Content Type",
  "http.postBody": "Request Body",
  "http.headers": "HTTP Headers",
  "http.urlParameters": "URL Parameters"
}
